import React from 'react';
import { CnLayoutSection as UICnLayoutSection } from '@/components/cn-layout/index';
import { AddTile } from '@/lowcode/cn-layout-section/components/add-tile';
import { getExtraDom, getExtraProps, getSlotDom } from './util';
import './view.scss';
const CnLayoutSection = (props) => {
    const { children, _layout } = props || {};
    const { componentSlot } = _layout || {};
    const extraDom = getExtraDom(props);
    const slotDom = getSlotDom(componentSlot);
    const extraProps = getExtraProps(props);
    return (<>
      <UICnLayoutSection extra={extraDom} {...extraProps}>
        {slotDom}
        {children}
        <AddTile {...props}/>
      </UICnLayoutSection>
    </>);
};
CnLayoutSection.displayName = 'CnLayoutSection';
export default CnLayoutSection;
export { CnLayoutSection };
